import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PERC_LINE_CHART } from '@app/shared/models/charts.model';
import {
  API_SUCCESS,
  CUSTOMIZE_ACTIVATION_CURVE_ERROR_MESSAGES as ERROR_MESSAGES,
  SOMETHING_WENT_WRONG,
} from '@constants/messages';
import { SessionStorageService } from 'angular-web-storage';
import * as Highcharts from 'highcharts';
import HC_Data from 'highcharts/modules/data';
import * as _ from 'lodash';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import * as model from './customize-activation-flyout.model';

import { HttpHandlerService } from '@app/shared/services/http-handler.service';
import { appSetting } from '@constants/endpoints';
import { DialogService } from '@app/shared/dependency/dialog';
import { ScenarioService } from '@app/featured-modules/modeling-predictions/modules/modeling-predictions-shared/scenarios.service';
import { DropdownConfigModel } from '../dropdown/shared/models/dropdown.model';

export interface CohortSharingRow {
  parent_dependency: string;
  sites_shared: string;
  combination_of_cohort: string[];
}

// ── Country row extended with new fields ──
export interface CountryGeographyRow {
  geographyName: string;
  siteActivationMethod: boolean;
  shareSiteNumber: string;
  sitesSharedAmongCohort: string[];
}

@Component({
  selector: 'app-customize-activation-flyout',
  templateUrl: './customize-activation-flyout.component.html',
  styleUrls: ['./customize-activation-flyout.component.scss'],
  standalone: false
})
export class CustomizeActivationFlyoutComponent implements OnInit {
  @Input() modal: NgbModalRef;
  @Input() chartOptions: Highcharts.Options;
  @Input() modelingLevel: string;
  @Input() accessMode: any;
  @Input() accessModeCustomize: any;
  @Input() geoLevelName: any;
  @Input() dateBounds: {
    minStartDate: any;
    maxEndDate: any;
  };
  @Input() flyoutData;
  @Input() elapsedDurationCust;
  @Input() expectedStartDate;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();

  highcharts = Highcharts;
  chart;
  requiredCoordinates = 5;

  focussedItem = { column: null, row: null };

  chartPlotted = false;
  isError = false;
  isErrorDate = false;
  errorMessage = '';
  errorMessageDate = '';
  inputRequest: any;
  disable_baseline_tracked: boolean;
  siteSharingCohortError: string = '';  // ← naya variable add karo class mein


  studyDetails: any;

  activeTab = 'global';
  activeIndex;
  originalGlobalData;
  originalCountryData;
  tabSwitchRequest;
  changesMade: boolean = false;
  savingInProgress: boolean = false;

  newPercentageCustomInputs = model.PERCENTAGE_CUSTOM_INPUT;
  newDateCustomInputs = model.DATE_CUSTOM_INPUT;

  inputGridData: any;
  geographyGridData: any;
  globalData: model.CUSTOM_ACTIVATION_DATA;
  countryData: Array<model.CUSTOM_ACTIVATION_DATA> = [];
  completeGlobalData;
  completeCountryData;
  currentActivationData;
  tabDataLoading: boolean = true;
  selectedGeographyData: any;
  countryList = [];

  countryTabEnabled: boolean = false;
  popupOpen: boolean = false;
  chartLoader: boolean = false;
  minSiteActivationDate = '';
  maxSiteActivationDate = '';
  scenarioDetails = '';
  alertConfig = {
    title: '',
    content: '',
    okButtonLabel: 'OK',
    cancelButtonLabel: 'Cancel',
    afterOk: () => { },
    afterCancel: () => { }
  };

  toolTip = {
    startDate: 'Site Activation Start Tooltip Placeholder',
    endDate: 'Site Activation End Tooltip Placeholder',
  };
  target_no_sites = 0;
  target_no_sites_toggle = false;
  date_toggle: boolean = false;

  // ── GLOBAL: Site Sharing variables (populated from API response) ──
  allSitesShared: boolean = true;
  cohortSharingRows: CohortSharingRow[] = [];
  availableCohorts: string[] = [];
  siteSharingSaveError: string = '';

  // ── COUNTRY: dropdown open state tracker per row ──
  countryDropdownOpen: boolean[] = [];

  @ViewChild('alertModal') alertModal;
  private currentModalRef: NgbModalRef;

  dropdownConfigurations = new DropdownConfigModel(
    null,  // ← yeh null tha, ab string do
    false, false, null, null, false, false, false, false, false, false, null, true, false
  );
  dropdownConfigurationsMulti = new DropdownConfigModel(
    'Select cohorts', // placeholder
    true,             // multiselect = TRUE
    false,            // selectall
    null,             // bindlabel
    null,             // bindvalue
    false,            // addtag
    false,            // lazyload
    false,            // searchable
    false,            // clearable
    false,            // localsearch
    false,            // disabled
    null,             // searchtext
    true,             // itemsimplearray
    false             // pushonaddtag
  );
  constructor(
    private localStorage: SessionStorageService,
    private httpHandler: HttpHandlerService,
    private scenarioService: ScenarioService,
    private dialog: DialogService,
    private ngbModal: NgbModal,
  ) {
    HC_Data(Highcharts);
  }

  openAlert(config) {
    this.alertConfig = {
      okButtonLabel: 'OK',
      cancelButtonLabel: 'Cancel',
      ...config
    };
    this.currentModalRef = this.ngbModal.open(this.alertModal, {
      windowClass: 'alert-modal-window',
      backdrop: 'static',
      centered: true,
      keyboard: false,
    });
  }

  ngOnInit(): void {
    this.studyDetails = this.localStorage.get('study-details');
    this.inputRequest = this.localStorage.get('inputRequest');
    this.scenarioDetails = this.localStorage.get('scenario-details');
    this.inputRequest.input_request.study_created_by = this.studyDetails.study_created_by;
    this.inputRequest.input_request.historical_data_id = this.studyDetails.historical_data_id;
    this.inputRequest.input_request.is_cohort = this.studyDetails.is_cohort;
    this.localStorage.set('inputRequest', this.inputRequest);
    this.originalGlobalData = JSON.parse(JSON.stringify(this.flyoutData.global_level_details[0]));
    this.originalCountryData = JSON.parse(JSON.stringify(this.flyoutData.geo_level_details));
    this.prepareFlyoutDisplayData(this.flyoutData);
    this.date_toggle = this.getToggleValue();

    // ── Init cohort list from scenario_cohort_details ──
    this.initCohortList();
    console.log('availableCohorts:', this.availableCohorts);
    console.log('dropdownConfigurations:', this.dropdownConfigurations);

    // ── Load global site sharing from API response ──
    this.initGlobalSiteSharing(this.flyoutData.global_level_details[0]);
  }

  // ── Initialize available cohorts from inputRequest ──
  private initCohortList(): void {
    const cohortDetails = this.inputRequest?.input_request?.scenario_cohort_details || [];
    this.availableCohorts = cohortDetails.map((c: any) => c.cohort_name || c).filter(Boolean);
  }

  // ── Load Global Site Sharing data from API response ──
  private initGlobalSiteSharing(globalData: any): void {
    this.allSitesShared = globalData.all_sites_shared ?? false;

    if (globalData.cohort_sharing && globalData.cohort_sharing.length > 0) {
      this.cohortSharingRows = globalData.cohort_sharing.map((row: any) => ({
        parent_dependency: row.parent_dependency || '',
        sites_shared: String(row.sites_shared || ''),
        combination_of_cohort: row.combination_of_cohort || [],
      }));
    } else {
      this.cohortSharingRows = [{
        parent_dependency: '',
        sites_shared: '',
        combination_of_cohort: [],
      }];
    }
  }

  // ── GLOBAL: Add new cohort sharing row — max N-1 rows (N = cohort count) ──
  addCohortSharingRow(): void {
    const maxRows = this.availableCohorts.length - 1;
    if (this.cohortSharingRows.length >= maxRows) { return; }
    this.cohortSharingRows.push({
      parent_dependency: '',
      sites_shared: '',
      combination_of_cohort: [],
    });
  }

  // ── GLOBAL: Remove cohort sharing row ──
  removeCohortSharingRow(index: number): void {
    this.cohortSharingRows.splice(index, 1);
  }

  // ── GLOBAL: All Sites Shared toggle ──
  onAllSitesSharedToggle(): void {
    this.allSitesShared = !this.allSitesShared;
  }
  // TS mein method add karo:
  shareNumberError: string = '';

  onShareSiteNumberChange(row: any): void {
    const feasibleInfo = this.flyoutData?.feasible_sharing?.[row.geographyName];
    const feasibleMax = feasibleInfo?.max_number_of_sites_share ?? null;
    if (feasibleMax !== null && Number(row.shareSiteNumber) > feasibleMax) {
      this.shareNumberError = `Share site number cannot exceed maximum allowed value of ${feasibleMax}`;
    } else {
      this.shareNumberError = '';
    }
  }

  // ── GLOBAL: Toggle cohort in combination_of_cohort (multi-select, no checkbox) ──
  toggleCohortInCombination(row: CohortSharingRow, cohortName: string): void {
    const idx = row.combination_of_cohort.indexOf(cohortName);
    if (idx > -1) {
      row.combination_of_cohort.splice(idx, 1);
    } else {
      row.combination_of_cohort.push(cohortName);
    }
  }

  isCohortSelectedInCombination(row: CohortSharingRow, cohortName: string): boolean {
    return row.combination_of_cohort.includes(cohortName);
  }

  getCombinationLabel(row: CohortSharingRow): string {
    if (!row.combination_of_cohort || row.combination_of_cohort.length === 0) {
      return 'Select cohorts';
    }
    return row.combination_of_cohort.join(', ');
  }

  // ── COUNTRY: Select change handler — same as onCombinationSelectChange ──
  onCountryCohortSelectChange(event: any, row: any): void {
    const selected = event.target.value;
    if (!selected) return;
    if (!row.sitesSharedAmongCohort) row.sitesSharedAmongCohort = [];
    const idx = row.sitesSharedAmongCohort.indexOf(selected);
    if (idx > -1) {
      row.sitesSharedAmongCohort.splice(idx, 1);
    } else {
      row.sitesSharedAmongCohort.push(selected);
    }
    // Reset select to placeholder
    event.target.value = '';
  }

  // ── COUNTRY: Toggle cohort in sitesSharedAmongCohort per geography row ──
  toggleCohortInCountryRow(row: any, cohortName: string): void {
    if (!row.sitesSharedAmongCohort) {
      row.sitesSharedAmongCohort = [];
    }
    const idx = row.sitesSharedAmongCohort.indexOf(cohortName);
    if (idx > -1) {
      row.sitesSharedAmongCohort.splice(idx, 1);
    } else {
      row.sitesSharedAmongCohort.push(cohortName);
    }
  }

  isCohortInCountryRow(row: any, cohortName: string): boolean {
    return (row.sitesSharedAmongCohort || []).includes(cohortName);
  }

  removeCohortFromCountryRow(row: any, cohortName: string): void {
    if (!row.sitesSharedAmongCohort) return;
    const idx = row.sitesSharedAmongCohort.indexOf(cohortName);
    if (idx > -1) {
      row.sitesSharedAmongCohort.splice(idx, 1);
    }
  }

  getCountryDropdownLabel(row: any): string {
    if (!row.sitesSharedAmongCohort || row.sitesSharedAmongCohort.length === 0) {
      return 'Select cohorts';
    }
    return row.sitesSharedAmongCohort.join(', ');
  }

  toggleCountryDropdown(index: number): void {
    this.countryDropdownOpen[index] = !this.countryDropdownOpen[index];
  }

  closeCountryDropdown(index: number): void {
    this.countryDropdownOpen[index] = false;
  }

  private plotChart(level, chartData: Array<[any, any]>, yAxisMax = 100, chartType = 'simulated'): void {
    this.chartLoader = true;
    const chartOptions: Highcharts.Options = JSON.parse(JSON.stringify(PERC_LINE_CHART));
    chartOptions.chart = {
      ...chartOptions.chart,
      height: null,
      reflow: true,
      animation: { duration: 800, easing: 'easeOutQuart' },
    };

    chartOptions.plotOptions.line.color = '' + model.CHART_CONFIG[chartType].lineColor;

    if (this.getToggleValue()) {
      chartData.splice(0, 0, [null, '']);
      chartOptions.series = [];
      chartOptions.xAxis['type'] = 'datetime';
      chartOptions.data['rows'] = chartData;
      chartOptions.data['dateFormat'] = 'YYYY/mm/dd';
      chartOptions.xAxis['tickInterval'] = undefined;

      if (chartData.length > 1) {
        chartOptions.xAxis['min'] = moment(chartData[1][0]).valueOf();
        chartOptions.xAxis['max'] = moment(chartData[chartData.length - 1][0]).add(1, 'days').valueOf();

        (chartOptions as any).xAxis.tickPositioner = function () {
          var positions = [],
            tick = moment(chartData[1][0]).valueOf(),
            increment = (moment(chartData[chartData.length - 1][0]).add(1, 'days').valueOf() - moment(chartData[1][0]).valueOf()) / 4;
          if (moment(chartData[chartData.length - 1][0]).add(1, 'days').valueOf() !== null && moment(chartData[1][0]).valueOf() !== null) {
            for (tick; tick - increment <= moment(chartData[chartData.length - 1][0]).add(1, 'days').valueOf(); tick += increment) {
              positions.push(tick);
            }
          }
          return positions;
        };
        (chartOptions as any).xAxis.labels.align = 'right';
      } else {
        (chartOptions as any).xAxis.tickPositioner = () => { return []; };
      }
      (chartOptions as any).xAxis.title.text = 'Date of Activation';
    } else {
      chartOptions.series = [{ type: 'line', name: 'Sites Activated', data: chartData }];
      chartOptions.xAxis['min'] = 0;
      chartOptions.xAxis['max'] = 100;
      (chartOptions as any).xAxis.tickPositioner = () => { return [0, 25, 50, 75, 100]; };
      (chartOptions as any).xAxis.type = 'linear';
      (chartOptions as any).xAxis.title.text = 'Site Activation Duration';
    }

    chartOptions.tooltip.formatter = (c): string => {
      const point = c.chart.hoverPoint;
      const xTooltip = this.getToggleValue()
        ? 'Date of Activation: <strong>' + Highcharts.dateFormat('%d %b %Y', point.x)
        : 'Site Activation Duration: <strong>' + point.x + '%';
      return `Sites Activated: <strong>${point.y}${this.target_no_sites_toggle ? '' : '%'}</strong><br>${xTooltip}</strong><br>`;
    };

    (chartOptions as any).yAxis.labels.formatter = (e: Highcharts.AxisLabelsFormatterContextObject): string => {
      return e.isFirst ? '' + e.value : `${e.value}${this.target_no_sites_toggle ? '' : '%'}`;
    };

    (chartOptions as any).xAxis.labels.formatter = (e): string => {
      const xLabel = this.getToggleValue() ? Highcharts.dateFormat('%d %b %Y', e.value) : e.value + '%';
      return e.isFirst ? '' : `${xLabel}`;
    };

    (chartOptions as any).yAxis = {
      min: 0,
      max: yAxisMax,
      tickInterval: yAxisMax / 5,
      labels: { formatter: (e) => { return e.value + (this.target_no_sites_toggle ? '' : '%'); } }
    };

    setTimeout(() => {
      if (this.chart) {
        this.chart.destroy();
        this.chart = new this.highcharts.Chart('chart-container', chartOptions);
      } else {
        this.chart = new this.highcharts.Chart('chart-container', chartOptions);
      }
      this.chart.reflow();
      this.chartPlotted = true;
    }, 0);
  }

  deleteCoordinate(index: number): void {
    if (!this.accessMode) return;
    this.changesMade = true;
    this.chartPlotted = false;
    this.inputGridData.splice(index, 1);
  }

  addCoordinate(type): void {
    if (!this.accessMode) return;
    const dataPoint = type
      ? JSON.parse(JSON.stringify(model.DATE_DATA_POINT))
      : JSON.parse(JSON.stringify(model.PERCENTAGE_DATA_POINT));
    this.inputGridData.splice(this.inputGridData.length - 1, 0, { ...dataPoint });
    this.chartPlotted = false;
    this.changesMade = true;
    setTimeout(() => {
      const ele = document.getElementById('input-grid');
      ele.scrollTop = ele.scrollHeight;
    }, 50);
  }

  displayError(errorMessage: string): void {
    this.errorMessage = errorMessage;
    const errorElement = document.getElementById('right-container');
    if (errorElement) errorElement.scrollTop = 0;
  }

  displayErrorDate(errorMessage: string): void {
    this.errorMessageDate = errorMessage;
    const errorElement = document.getElementById('right-container');
    if (errorElement) errorElement.scrollTop = 0;
  }

  modalDismissed(action: string): void {
    if (action === 'Update' && this.activeTab == 'global') {
      this.savingInProgress = true;
      this.prepareSaveData(true);
    } else if (action === 'Update' && this.activeTab == 'country') {
      this.savingInProgress = true;
      this.prepareSaveData(false);
    } else {
      this.popupOpen = true;
      if (this.accessMode && (this.checkForChangesOnTab('country') || this.checkForChangesOnTab('global') || this.changesMade)) {
        this.openAlert({
          title: model.CANCEL_MODAL.modalTitle,
          content: model.CANCEL_MODAL.modalMessage,
          afterOK: () => {
            this.popupOpen = false;
            this.modalClosed.emit({ action: 'Cancel' });
            this.currentModalRef.close();
            this.modal.close();
          },
          afterCancel: () => { this.popupOpen = false; this.currentModalRef.close(); },
          afterClose: () => { this.popupOpen = false; this.currentModalRef.close(); },
        });
      } else {
        this.modalClosed.emit({ action: 'Cancel' });
        this.modal.close();
      }
    }
  }

  openTabSwitchPopup(tab) {
    this.errorMessage = '';
    if (this.checkForChangesOnTab(this.activeTab) || this.changesMade) {
      this.popupOpen = true;
      this.openAlert({
        title: model.CONFIRMATION_MODAL.modalTitle,
        content: model.CONFIRMATION_MODAL.modalMessage,
        afterOK: () => { this.popupOpen = false; this.setTab(tab); this.currentModalRef.close(); },
        afterCancel: () => { this.popupOpen = false; this.currentModalRef.close(); },
        afterClose: () => { this.popupOpen = false; this.currentModalRef.close(); },
      });
    } else {
      this.setTab(tab);
    }
  }

  checkForChangesOnTab(tab) {
    return tab === 'global'
      ? !_.isEqual(this.globalData, this.completeGlobalData)
      : !_.isEqual(this.countryData, this.completeCountryData);
  }

  enableCountryTab() {
    return (
      (this.inputRequest.input_request.study_feasibility === 'pre' && this.inputRequest.input_request.modelling_level === 'Country') ||
      (this.inputRequest.input_request.study_feasibility === 'post' &&
        (this.inputRequest.input_request.modelling_level === 'Country' || this.inputRequest.input_request.modelling_level === 'Region'))
    );
  }

  hasMandatoryFields() {
    let unfilledInputs = 0;
    this.inputGridData.forEach(el => {
      const durationInp = this.getToggleValue() ? el.perc_trial_duration.input : el.perc_trial_duration;
      if (el.perc_site_activated === null || el.perc_site_activated === '' || durationInp === null || durationInp === '') {
        unfilledInputs += 1;
      }
    });
    return !Boolean(unfilledInputs);
  }

  ifNoHistoricalData(): any {
    if (this.studyDetails.study_feasibility === 'post' || this.inputRequest.input_request.study_feasibility === 'post') {
      return false;
    } else if (this.activeTab === 'country' && (this.inputRequest.input_request.historical_data_id === '' || this.inputRequest.input_request.historical_data_id === null)) {
      let tempArr = [];
      this.countryData.forEach(item => {
        if (item.siteActivationMethod && this.globalData.siteActivationMethod) {
        } else if (!item.siteActivationMethod && item.custom.dateCustom.length <= 0 && item.custom.percentageCustom.length <= 0) {
        } else { tempArr.push(item); }
      });
      return this.countryData.length !== tempArr.length;
    } else {
      return this.activeTab === 'global' && this.globalData.siteActivationMethod && this.checkforHistoricalId();
    }
  }

  checkforHistoricalId(): any {
    const scenario = this.localStorage.get('scenario-details');
    const histId = this.inputRequest?.input_request?.historical_data_id;
    return histId === '' || histId === null;
  }

  saveFlyoutData(data) {
    const inp = Object.assign({}, this.inputRequest);
    const endpoint = this.inputRequest.input_request.study_feasibility == 'pre'
      ? appSetting.PRE_SAVE_HISTORICAL_CUSTOM_DETAILS
      : appSetting.SAVE_HISTORICAL_FLYOUT_DATA;

    // ── Include site sharing fields in global payload ──
    const globalPayload = {
      ...data.global,
      all_sites_shared: this.allSitesShared,
      cohort_sharing: this.cohortSharingRows.map(r => ({
        parent_dependency: r.parent_dependency,
        sites_shared: r.sites_shared,
        combination_of_cohort: r.combination_of_cohort,
      })),
    };

    // ── Include share_site_number and sites_shared_among_cohort in country payload ──
    const countryPayload = data.country.map((c: any, i: number) => ({
      ...c,
      share_site_number: this.geographyGridData[i]?.shareSiteNumber || '',
      sites_shared_among_cohort: this.geographyGridData[i]?.sitesSharedAmongCohort || [],
    }));

    const payload = {
      input_request: {
        user_group: inp.input_request.user_group,
        user_id: inp.input_request.user_id,
        theme_id: inp.input_request.theme_id,
        study_id: inp.input_request.study_id,
        study_type: inp.input_request.study_type || '',
        scenario_id: inp.input_request.scenario_id,
        new_scenario_version: inp.input_request.new_scenario_version,
        historical_data_id: inp.input_request.historical_data_id,
        modelling_level: inp.input_request.modelling_level,
        forecast_type: inp.input_request.forecast_type,
        study_created_by: inp.input_request.study_created_by,
        scenario_created_by: inp.input_request.scenario_created_by,
        is_cohort: inp.input_request.is_cohort,
        cohort_type: inp.input_request.cohort_type,
        geo_level_details: countryPayload,
        global_level_details: [globalPayload],
        customize_activation: this.activeTab === 'global' ? 'Global' : 'Country',
      },
    };

    this.httpHandler.postHttpResults(endpoint, payload).subscribe(
      response => {
        if (response.status === 'SUCCEEDED') {
          this.changesMade = false;
          this.modalClosed.emit({
            action: 'Update',
            custom_modeling_level: this.activeTab === 'global' ? 'Global' : 'Country',
            site_activation_method: 'Custom',
            isFlyoutCustomized: true,
            max_site_activation_start_date: this.activeTab === 'global' ? data.global.site_activation_start_date : this.minSiteActivationDate,
            min_site_activation_end_date: this.activeTab === 'global' ? data.global.site_activation_end_date : this.maxSiteActivationDate,
          });
          this.savingInProgress = false;
          this.modal.close();
        } else {
          this.savingInProgress = false;
          this.displayError(SOMETHING_WENT_WRONG);
        }
      },
      () => { this.savingInProgress = false; this.displayError(SOMETHING_WENT_WRONG); }
    );
  }

  onGridInputFocus(index: number, field: string): void {
    this.focussedItem = { row: index, column: field };
  }

  onGridInputFocusOut(index: number, field: string): void {
    this.chartPlotted = false;
    if (this.isError) {
      this.inputGridData[index][field] = null;
      this.displayError('');
      this.isError = false;
    }
  }

  isGridInputDisabled(index: number, field: string): boolean {
    const field1 = 'perc_trial_duration';
    const field2 = 'perc_site_activated';
    const field3 = 'target_no_sites';

    if (this.currentActivationData.siteActivationMethod || !this.accessMode) return true;
    else if (!this.currentActivationData.toggleSelection) {
      return (
        this.inputGridData[index - 1][field1] === null || this.inputGridData[index - 1][field2] === null ||
        this.inputGridData[index - 1][field3] === null || this.inputGridData[index - 1][field1] === '' ||
        this.inputGridData[index - 1][field2] === '' || this.inputGridData[index - 1][field3] === ''
      );
    } else {
      return (
        this.inputGridData[index - 1][field2] === null || this.inputGridData[index - 1][field2] === '' ||
        this.inputGridData[index - 1][field1].input === '' || this.inputGridData[index - 1][field1].input === null ||
        this.inputGridData[index - 1][field3].input === '' || this.inputGridData[index - 1][field3].input === null
      );
    }
  }

  disableSave() {
    const method = this.currentActivationData.siteActivationMethod;
    return (
      !this.accessMode ||
      this.inputRequest.input_request.forecast_type === 'refresh_forecast' ||
      this.popupOpen || !this.chartPlotted || !this.hasMandatoryFields() ||
      this.isError || this.isErrorDate ||
      (method === 'historical' && !this.ifNoHistoricalData()) ||
      this.currentActivationData.siteStartDate.input === '' ||
      this.currentActivationData.siteEndDate.input === '' ||
      method === '' || method == null
    );
  }

  legendToggle(level, index, event, bypass, toggle = '') {
    if (toggle == 'date') this.date_toggle = event.target.checked;
    if (toggle == 'no_of_sites') this.target_no_sites_toggle = event.target.checked;
    if (this.currentActivationData.siteActivationMethod) {
      return;
    } else if (this.currentActivationData.siteStartDate.input == '' || this.currentActivationData.siteEndDate.input == '') {
      this.displayError('Please enter site activation start and end date first');
    } else if (!this.chartPlotted && !bypass) {
      this.popupOpen = true;
      this.openAlert({
        title: model.CALCULATE_ACTIVATION_MODAL.modalTitle,
        content: model.CALCULATE_ACTIVATION_MODAL.modalMessage,
        afterOK: () => { this.popupOpen = false; this.legendToggle(level, index, event, true, toggle); this.currentModalRef.close(); },
        afterCancel: () => { this.popupOpen = false; event.target.checked = !event.target.checked; this.currentModalRef.close(); return; },
        afterClose: () => { this.popupOpen = false; event.target.checked = !event.target.checked; this.currentModalRef.close(); return; },
      });
    } else {
      this.changesMade = true;
      this.currentActivationData.toggleSelection = this.date_toggle;
      const gridData = this.date_toggle ? this.selectedGeographyData.custom.dateCustom : this.selectedGeographyData.custom.percentageCustom;
      if (this.target_no_sites_toggle) {
        gridData.forEach((itm, i) => {
          itm.target_no_sites = Math.round((itm.perc_site_activated * this.selectedGeographyData.target_no_sites) / 100);
        });
      }
      this.setCurrentInputGridData(gridData.length ? gridData : this.createDefaultInputs(event.target.checked));
      this.inputGridData.forEach((_, i) => { this.percentageNumCOnvertor(i, false); });
      this.createChart(level, gridData, index, this.getToggleValue(), false);
    }
  }

  convertToDateModel(date) {
    let d = moment(date).format('YYYY-MM-DD');
    let d1 = d.split('-');
    return {
      input: date.length ? moment(date).format('DD MMM YYYY') : '',
      model: { year: +d1[0], month: +d1[1], day: +d1[2] },
    };
  }

  convertDateToString(date) {
    return moment(date).format('YYYY-MM-DD').toString();
  }

  prepareSaveData(save) {
    const customData: any = { country: [], global: {} };

    let gc = {};
    if (this.globalData.toggleSelection) {
      this.globalData.custom.dateCustom.forEach((cd: any) => {
        gc[this.convertDateToString(cd.perc_trial_duration.input)] = cd.perc_site_activated.toString();
      });
    } else {
      this.globalData.custom.percentageCustom.forEach((cd: any) => {
        gc[cd.perc_trial_duration.toString()] = cd.perc_site_activated.toString();
      });
    }

    customData.global = {
      geo_level_name: this.globalData.geographyName,
      historical: this.originalGlobalData.historical,
      custom: gc,
      site_activation_start_date: this.convertDateToString(this.globalData.siteStartDate.input),
      site_activation_end_date: this.convertDateToString(this.globalData.siteEndDate.input),
      legend_toggle: this.globalData.toggleSelection ? 'date' : 'percentage',
      site_activation_method: this.globalData.siteActivationMethod ? 'Historical' : 'Custom',
    };

    this.countryData.forEach(country => {
      const cc = {};
      if (country.toggleSelection && country.custom.dateCustom.length > 0) {
        country.custom.dateCustom.forEach((cd: any) => {
          cc[this.convertDateToString(cd.perc_trial_duration.input)] = cd.perc_site_activated.toString();
        });
      } else if (country.custom.percentageCustom.length > 0) {
        country.custom.percentageCustom.forEach((cd: any) => {
          cc[cd.perc_trial_duration.toString()] = cd.perc_site_activated.toString();
        });
      }
      customData.country.push({
        geo_level_name: country.geographyName,
        custom: cc,
        site_activation_start_date: this.convertDateToString(country.siteStartDate.input),
        site_activation_end_date: this.convertDateToString(country.siteEndDate.input),
        legend_toggle: country.toggleSelection ? 'date' : 'percentage',
        site_activation_method: country.siteActivationMethod ? 'Historical' : 'Custom',
      });
    });

    if (save) { this.generateNewVersionId(customData); } else { this.countrySiteActivationValidationAPI(customData); }
  }

  createDefaultInputs(inputType) {
    let defaultInputs;
    if (inputType === true) {
      defaultInputs = model.DATE_CUSTOM_INPUT;
      defaultInputs[0].perc_trial_duration = Object.assign({}, this.currentActivationData.siteStartDate);
      defaultInputs.slice(-1)[0].perc_trial_duration = Object.assign({}, this.currentActivationData.siteEndDate);
    } else {
      defaultInputs = model.PERCENTAGE_CUSTOM_INPUT;
    }
    return JSON.parse(JSON.stringify(defaultInputs));
  }

  setCurrentInputGridData(data) {
    this.inputGridData = data;
    this.inputGridData.target_no_sites = this.target_no_sites;
    this.inputGridData.forEach((item, index) => {
      if (item.perc_site_activated || index == 0) this.percentageNumCOnvertor(index, false);
      else item.target_no_sites = null;
    });
  }

  setCurrentGeographyGridData(data) {
    this.geographyGridData = data;
  }

  setCurrentActivationData(startDate, endDate, activationType, toggleSelection) {
    this.currentActivationData = {
      siteStartDate: startDate.input == '' ? this.convertToDateModel(this.dateBounds.minStartDate) : startDate,
      siteEndDate: endDate.input == '' ? this.convertToDateModel(this.dateBounds.maxEndDate) : endDate,
      siteActivationMethod: activationType,
      toggleSelection: toggleSelection,
    };
    this.tabDataLoading = false;
  }

  prepareFlyoutDisplayData(result) {
    let localGlobalData = result.global_level_details[0];
    let localCountryData = result.geo_level_details;

    const global_hist = [];
    const global_hist_k = Object.keys(localGlobalData.historical);
    const global_hist_v = Object.values(localGlobalData.historical);
    if (this.studyDetails.historical_data_available != 'N') {
      for (let x = 0; x < global_hist_k.length; x++) {
        global_hist.push({ perc_trial_duration: +global_hist_k[x], perc_site_activated: +global_hist_v[x] });
      }
    }

    const global_cust_date = [];
    const global_cust_perc = [];
    const global_cust_k = Object.keys(localGlobalData.custom);
    const global_cust_v = Object.values(localGlobalData.custom);
    if (localGlobalData.legend_toggle === 'date') {
      for (let x = 0; x < global_cust_k.length; x++) {
        global_cust_date.push({ perc_trial_duration: this.convertToDateModel(global_cust_k[x]), perc_site_activated: +global_cust_v[x] });
      }
    } else {
      for (let x = 0; x < global_cust_k.length; x++) {
        global_cust_perc.push({ perc_trial_duration: +global_cust_k[x], perc_site_activated: +global_cust_v[x] });
      }
    }

    this.globalData = {
      geographyName: localGlobalData.geo_level_name,
      historical: global_hist,
      target_no_sites: +localGlobalData.target_no_sites,
      custom: { dateCustom: global_cust_date, percentageCustom: global_cust_perc },
      siteActivationMethod: this.studyDetails.historical_data_available == 'N' ? false : localGlobalData.site_activation_method === 'Historical' ? true : false,
      toggleSelection: localGlobalData.legend_toggle === 'date' ? true : false,
      siteStartDate: this.convertToDateModel(
        localGlobalData.site_activation_start_date != ''
          ? moment.max(moment(localGlobalData.site_activation_start_date), moment(this.dateBounds.minStartDate)).format('YYYY-MM-DD').toString()
          : this.dateBounds.minStartDate
      ),
      siteEndDate: this.convertToDateModel(
        localGlobalData.site_activation_end_date != ''
          ? moment.min(moment(localGlobalData.site_activation_end_date), moment(this.dateBounds.maxEndDate)).format('YYYY-MM-DD').toString()
          : this.dateBounds.maxEndDate
      ),
    };

    localCountryData.map((country, idx) => {
      const country_cust_date = [];
      const country_cust_perc = [];
      const country_cust_k = Object.keys(country.custom);
      const country_cust_v = Object.values(country.custom);

      if (country.legend_toggle === 'date') {
        for (let x = 0; x < country_cust_k.length; x++) {
          country_cust_date.push({ perc_trial_duration: this.convertToDateModel(country_cust_k[x]), perc_site_activated: +country_cust_v[x] });
        }
      } else {
        for (let x = 0; x < country_cust_k.length; x++) {
          country_cust_perc.push({ perc_trial_duration: +country_cust_k[x], perc_site_activated: +country_cust_v[x] });
        }
      }

      // FIX 1: feasible_sharing se max_number_of_sites_share prefill karo
      const feasibleInfo = result.feasible_sharing?.[country.geo_level_name];
      const maxSitesFromFeasible = feasibleInfo?.max_number_of_sites_share ?? null;
      const feasibleCohorts: string[] = feasibleInfo?.cohorts || [];

      // FIX 2: agar country sirf ek cohort mein hai toh row disable karo
      const isRowDisabled = feasibleCohorts.length <= 1;

      const countryObj: any = {
        geographyName: country.geo_level_name,
        historical: localGlobalData.site_activation_method === 'Historical' ? global_hist : localGlobalData.legend_toggle === 'date' ? global_cust_date : global_cust_perc,
        target_no_sites: country.target_no_sites,
        custom: { dateCustom: country_cust_date, percentageCustom: country_cust_perc },
        siteActivationMethod: country.site_activation_method === 'Historical'
          ? (this.studyDetails.historical_data_available != 'N' || localGlobalData.site_activation_method === 'Custom' ? true : false)
          : false,
        toggleSelection: country.legend_toggle === 'date' ? true : false,
        siteStartDate: this.convertToDateModel(country.site_activation_start_date || localGlobalData.site_activation_start_date || this.dateBounds.minStartDate),
        siteEndDate: this.convertToDateModel(country.site_activation_end_date || localGlobalData.site_activation_end_date || this.dateBounds.maxEndDate),
        // FIX: feasible_sharing se shareSiteNumber prefill; sirf ek cohort → disable
        shareSiteNumber: country.share_site_number || (maxSitesFromFeasible != null ? String(maxSitesFromFeasible) : ''),
        sitesSharedAmongCohort: country.sites_shared_among_cohort || [],
        isRowDisabled: isRowDisabled,
        feasibleCohorts: feasibleCohorts,
      };

      this.countryData.push(countryObj);
      this.countryDropdownOpen.push(false);
      this.countryList.push({
        geographyName: country.geo_level_name,
        siteActivationMethod: country.site_activation_method === 'Historical'
          ? (this.studyDetails.historical_data_available != 'N' || localGlobalData.site_activation_method === 'Custom' ? true : false)
          : false,
        shareSiteNumber: country.share_site_number || (maxSitesFromFeasible != null ? String(maxSitesFromFeasible) : ''),
        sitesSharedAmongCohort: country.sites_shared_among_cohort || [],
        isRowDisabled: isRowDisabled,
        feasibleCohorts: feasibleCohorts,
      });
    });

    this.completeGlobalData = JSON.parse(JSON.stringify(this.globalData));
    this.completeCountryData = JSON.parse(JSON.stringify(this.countryData));
    this.setTab(this.activeTab);
  }

  setGeography(level, index, callForActivationChange) {
    this.activeIndex = index;
    this.selectedGeographyData = level === 'global'
      ? JSON.parse(JSON.stringify(this.globalData))
      : JSON.parse(JSON.stringify(this.countryData[index]));
    const activation = callForActivationChange !== null ? callForActivationChange : this.selectedGeographyData.siteActivationMethod;
    const gridData = activation
      ? this.selectedGeographyData.historical
      : this.selectedGeographyData.toggleSelection
        ? this.selectedGeographyData.custom.dateCustom
        : this.selectedGeographyData.custom.percentageCustom;
    gridData.target_no_sites = this.selectedGeographyData.target_no_sites;
    if (gridData.length && level === 'global') { this.globalData.siteActivationMethod = activation; }
    else if (gridData.length) { this.countryData[index].siteActivationMethod = activation; }
    this.target_no_sites = gridData.target_no_sites;
    this.setCurrentActivationData(this.selectedGeographyData.siteStartDate, this.selectedGeographyData.siteEndDate, activation, this.selectedGeographyData.toggleSelection);
    this.setCurrentInputGridData(gridData.length ? gridData : this.createDefaultInputs(this.selectedGeographyData.toggleSelection));
    this.createChart(level, gridData, index, this.getToggleValue(), false);
  }

  setTab(tab) {
    this.activeTab = tab;
    this.changesMade = false;
    this.globalData = JSON.parse(JSON.stringify(this.completeGlobalData));
    this.countryData = JSON.parse(JSON.stringify(this.completeCountryData));
    let geographyList = [];
    if (tab === 'global') {
      geographyList.push({ geographyName: this.globalData.geographyName, siteActivationMethod: this.globalData.siteActivationMethod });
    } else {
      this.countryData.forEach(country => {
        geographyList.push({
          geographyName: country.geographyName,
          siteActivationMethod: country.siteActivationMethod,
          shareSiteNumber: (country as any).shareSiteNumber || '',
          sitesSharedAmongCohort: (country as any).sitesSharedAmongCohort || [],
          isRowDisabled: (country as any).isRowDisabled || false,
          feasibleCohorts: (country as any).feasibleCohorts || [],
        });
      });
    }
    this.setCurrentGeographyGridData(geographyList);
    this.setGeography(tab, 0, null);
  }

  changeGridData(level, index) {
    if (level === 'global' || this.activeIndex === index) return;
    else if (this.changesMade) {
      this.popupOpen = true;
      this.openAlert({
        title: model.CALCULATE_ACTIVATION_MODAL.modalTitle,
        content: model.CALCULATE_ACTIVATION_MODAL.modalMessage,
        afterOK: () => {
          this.geographyGridData.filter(row => row.geographyName == this.selectedGeographyData.geographyName).map(r => (r.siteActivationMethod = this.selectedGeographyData.siteActivationMethod));
          this.setGeography(level, index, null);
          this.currentModalRef.close();
          this.popupOpen = false;
        },
        afterCancel: () => { this.popupOpen = false; this.currentModalRef.close(); return; },
        afterClose: () => { this.popupOpen = false; this.currentModalRef.close(); return; },
      });
    } else {
      this.geographyGridData.filter(row => row.geographyName == this.selectedGeographyData.geographyName).map(r => (r.siteActivationMethod = this.selectedGeographyData.siteActivationMethod));
      this.setGeography(level, index, null);
    }
  }

  validateSiteDates(level, datepicker, field, index) {
    this.displayError('');
    this.displayErrorDate('');
    this.changesMade = true;

    if (!moment(datepicker._inputValue).isBetween(this.dateBounds.minStartDate, this.dateBounds.maxEndDate, null, '[]')) {
      this.displayError('Please add a date within the study duration range.');
      this.setDate(datepicker, field, true, 0);
    } else if (field === 'siteEndDate' && this.currentActivationData.siteStartDate.input !== '' && moment(datepicker._inputValue).isBefore(this.currentActivationData.siteStartDate.input)) {
      this.displayError('Please add a date after site activation start date.');
      this.setDate(datepicker, field, true, 0);
    } else if (field === 'siteStartDate' && this.currentActivationData.siteEndDate.input !== '' && moment(datepicker._inputValue).isAfter(this.currentActivationData.siteEndDate.input)) {
      this.displayError('Please add a date before site activation end date.');
      this.setDate(datepicker, field, true, 0);
    } else if (this.checkDatesOutOfBound(datepicker, field)) {
      this.displayError('Your input is cleared due to change in Site Activation End date.');
      this.setCurrentInputGridData(JSON.parse(JSON.stringify(this.createDefaultInputs(true))));
      if (level == 'global') { this.globalData.custom.dateCustom = []; } else { this.countryData[index].custom.dateCustom = []; }
      this.setDate(datepicker, field, false, index, level);
    } else {
      this.setDate(datepicker, field, false, index, level);
    }

    if (this.currentActivationData.siteStartDate.input.length > 0 && this.currentActivationData.siteEndDate.input) {
      if (this.calculateDuration(this.currentActivationData.siteStartDate.input, this.currentActivationData.siteEndDate.input) < this.elapsedDurationCust) {
        this.displayErrorDate('Complete Site Activation By duration should be greater than currently elapsed site activation duration.');
        this.isErrorDate = true;
      } else {
        this.displayErrorDate('');
        this.isErrorDate = false;
      }
    }
  }

  calculateDuration(startDate, endDate) {
    return moment(endDate).diff(moment(startDate), 'months', true).toFixed(1);
  }

  setDate(datepicker, field, reset, index, level?) {
    datepicker.close();
    this.isError = false;
    if (reset && (field === 'siteStartDate' || field === 'siteEndDate')) {
      this.currentActivationData[field] = this.convertToDateModel('');
    } else if (field === 'siteStartDate' || field === 'siteEndDate') {
      this.currentActivationData[field].input = datepicker._inputValue;
      this.currentActivationData[field].model = datepicker._model;
      if (field === 'siteStartDate' && this.currentActivationData.toggleSelection) {
        this.inputGridData[0].perc_trial_duration.input = datepicker._inputValue;
        this.inputGridData[0].perc_trial_duration.model = datepicker._model;
        this.chartPlotted = false;
      } else if (field === 'siteEndDate' && this.currentActivationData.toggleSelection) {
        this.inputGridData.slice(-1)[0].perc_trial_duration.input = datepicker._inputValue;
        this.inputGridData.slice(-1)[0].perc_trial_duration.model = datepicker._model;
        this.chartPlotted = false;
      }
      if (level === 'global') { this.globalData[field].input = datepicker._inputValue; this.globalData[field].model = datepicker._model; }
      else { this.countryData[index][field].input = datepicker._inputValue; this.countryData[index][field].model = datepicker._model; }
    } else if (reset) {
      this.inputGridData[index].perc_trial_duration = this.convertToDateModel('');
    } else {
      this.inputGridData[index].perc_trial_duration.input = datepicker._inputValue;
      this.inputGridData[index].perc_trial_duration.model = datepicker._model;
    }
  }

  siteActivationMethodChanged(level, activationType, bypass) {
    this.changesMade = true;
    this.geographyGridData.filter(row => row.geographyName == this.selectedGeographyData.geographyName).map(r => (r.siteActivationMethod = activationType));
    this.setGeography(level, this.activeIndex, activationType);
  }

  createChart(level, data, index, toggle, retainData) {
    if (data.length && retainData) {
      this.retainGridData(level, index);
    } else {
      const chartData: Array<[any, number]> = data.map(el => {
        const durationInput = toggle ? moment(el.perc_trial_duration.input).format('YYYY/MM/DD') : Number(el.perc_trial_duration);
        return [durationInput, this.target_no_sites_toggle ? Number(el.target_no_sites) : Number(el.perc_site_activated)];
      });
      let yAxisMax = 100;
      if (this.target_no_sites_toggle) {
        const maxValue = Math.max(...chartData.map(d => d[1]));
        const niceSteps = [1, 2, 5, 10];
        const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
        let niceMax = magnitude;
        for (let step of niceSteps) { if (maxValue <= step * magnitude) { niceMax = step * magnitude; break; } }
        yAxisMax = niceMax;
      }
      this.plotChart('', chartData, yAxisMax);
      this.changesMade = false;
    }
  }

  retainGridData(level, index) {
    if (level == 'global') {
      this.globalData.siteActivationMethod = this.currentActivationData.siteActivationMethod;
      this.globalData.siteStartDate = this.currentActivationData.siteStartDate;
      this.globalData.siteEndDate = this.currentActivationData.siteEndDate;
      this.globalData.toggleSelection = this.currentActivationData.toggleSelection;
      if (this.currentActivationData.toggleSelection && !this.currentActivationData.siteActivationMethod) { this.globalData.custom.dateCustom = this.inputGridData; }
      else if (!this.currentActivationData.siteActivationMethod) { this.globalData.custom.percentageCustom = this.inputGridData; }
    } else {
      this.countryData[index].siteActivationMethod = this.currentActivationData.siteActivationMethod;
      this.countryData[index].siteStartDate = this.currentActivationData.siteStartDate;
      this.countryData[index].siteEndDate = this.currentActivationData.siteEndDate;
      this.countryData[index].toggleSelection = this.currentActivationData.toggleSelection;
      if (this.currentActivationData.toggleSelection && !this.currentActivationData.siteActivationMethod) { this.countryData[index].custom.dateCustom = this.inputGridData; }
      else if (!this.currentActivationData.siteActivationMethod) { this.countryData[index].custom.percentageCustom = this.inputGridData; }
    }
    this.setGeography(level, index, false);
  }

  percentageNumCOnvertor(index, invert: boolean) {
    if (invert) {
      this.inputGridData[index].perc_site_activated = +(((this.inputGridData[index].target_no_sites / this.target_no_sites) * 100).toFixed(1));
    } else {
      this.inputGridData[index].target_no_sites = +((this.inputGridData[index].perc_site_activated * this.target_no_sites) / 100).toFixed(0);
    }
  }

  setGridData(inputEvent, index, field) {
    this.changesMade = true;
    let errorMsg;
    this.displayError('');

    if (this.currentActivationData.toggleSelection && field == 'perc_trial_duration') {
      this.chartPlotted = false;
      const date = moment(inputEvent._inputValue);
      const siteStartDate = moment(this.currentActivationData.siteStartDate.input);
      const siteEndDate = moment(this.currentActivationData.siteEndDate.input);
      const prevDate = moment(this.inputGridData[index - 1].perc_trial_duration.input);
      const nextDate = moment(this.inputGridData[index + 1].perc_trial_duration.input);

      if ((date.diff(siteStartDate) < 0 || date.diff(siteEndDate) >= 0) && !date.isSame(siteStartDate) && !date.isSame(siteEndDate)) {
        errorMsg = 'Please add a date within the site duration range.';
      } else if ((date.diff(prevDate) < 0 || date.diff(nextDate) >= 0) && !date.isSame(prevDate) && !date.isSame(nextDate)) {
        errorMsg = "Please enter 'Date of Activation' & '% Site Activated' value greater than the previous value & less than the next value in the column.";
      } else if (date.isSame(prevDate) || date.isSame(nextDate)) {
        errorMsg = 'Entered "Date of Activation" already exists.';
      } else {
        errorMsg = '';
        this.setDate(inputEvent, field, false, index);
      }
      if (errorMsg.length) { this.displayError(errorMsg); this.setDate(inputEvent, field, true, index); }
    } else {
      const currValue = Number(inputEvent);
      switch (field) {
        case 'perc_trial_duration': {
          const isDuplicate = this.inputGridData.some((el, i) => Number(el.perc_trial_duration) === currValue && i !== index && inputEvent !== null);
          if (inputEvent === null || inputEvent === '' || (currValue > 0 && currValue < 100)) {
            const prevValue = this.inputGridData[index - 1].perc_trial_duration;
            const nextValue = this.inputGridData[index + 1].perc_trial_duration;
            if (isDuplicate) { this.displayError(ERROR_MESSAGES.duplicateTrialDuration); this.isError = true; }
            else if (inputEvent !== null && inputEvent !== '' && ((prevValue !== null && prevValue !== '' && Number(prevValue) > currValue) || (nextValue !== null && nextValue !== '' && Number(nextValue) < currValue))) {
              this.displayError(ERROR_MESSAGES.badOrder); this.isError = true;
            } else { this.displayError(''); this.isError = false; }
          } else { this.displayError(ERROR_MESSAGES.trialDurationOutOfRange); this.isError = true; }
          break;
        }
        case 'perc_site_activated': {
          if (inputEvent === null || inputEvent === '' || (currValue >= 0 && currValue <= 100)) {
            const prevValue = this.inputGridData[index - 1].perc_site_activated;
            const nextValue = this.inputGridData[index + 1].perc_site_activated;
            if (inputEvent !== null && inputEvent !== '' && ((prevValue !== null && prevValue !== '' && Number(prevValue) > currValue) || (nextValue !== null && nextValue !== '' && Number(nextValue) < currValue))) {
              this.displayError(ERROR_MESSAGES.badOrder); this.isError = true;
            } else { this.displayError(''); this.isError = false; this.percentageNumCOnvertor(index, false); }
          } else { this.displayError(ERROR_MESSAGES.sitesActivatedOutOfRange); this.isError = true; }
          break;
        }
        case 'target_no_sites': {
          if (inputEvent === null || inputEvent === '' || (currValue >= 0 && currValue <= this.inputGridData.target_no_sites)) {
            const prevValue = this.inputGridData[index - 1].target_no_sites;
            const nextValue = this.inputGridData[index + 1].target_no_sites;
            if (inputEvent !== null && inputEvent !== '' && ((prevValue !== null && prevValue !== '' && Number(prevValue) > currValue) || (nextValue !== null && nextValue !== '' && Number(nextValue) < currValue))) {
              this.displayError(ERROR_MESSAGES.badOrderNo); this.isError = true;
            } else { this.displayError(''); this.isError = false; this.percentageNumCOnvertor(index, true); }
          } else { this.displayError(ERROR_MESSAGES.sitesActivatedOutOfRangeNo); this.isError = true; }
          break;
        }
      }
    }
  }

  countrySiteActivationValidationAPI(data) {
    const inp = this.localStorage.get('inputRequest');
    const payload = {
      input_request: {
        user_id: inp.input_request.user_id,
        theme_id: inp.input_request.theme_id,
        study_id: inp.input_request.study_id,
        scenario_id: inp.input_request.scenario_id,
        scenario_version: inp.input_request.new_scenario_version?.length ? inp.input_request.new_scenario_version : inp.input_request.old_scenario_version,
        study_feasibility: inp.input_request.study_feasibility,
        modelling_level: inp.input_request.modelling_level,
        custom_modelling_level: 'country',
        study_start_date: this.convertDateToString(this.dateBounds.minStartDate),
        expected_enrollment_completion_date: this.convertDateToString(this.dateBounds.maxEndDate),
        geo_level_details: data.country,
      },
    };

    this.httpHandler.postHttpResults(appSetting.VALIDATE_SITE_ACTIVATION_DATES, payload).subscribe(
      response => {
        if (response.status === API_SUCCESS && response.result.date_validation_flag === 'valid') {
          this.generateNewVersionId(data);
          this.minSiteActivationDate = response.result.site_activation_start_date;
          this.maxSiteActivationDate = response.result.site_activation_end_date;
        } else if (response.status === API_SUCCESS && response.result.date_validation_flag === 'invalid') {
          this.savingInProgress = false;
          this.displayError('Please enter site activation dates within study duration range for all countries.');
        } else {
          this.savingInProgress = false;
          this.displayError(SOMETHING_WENT_WRONG);
        }
      },
      () => { this.savingInProgress = false; this.displayError(SOMETHING_WENT_WRONG); }
    );
  }

  getToggleValue() {
    if (this.activeTab === 'global' && this.currentActivationData.siteActivationMethod) return false;
    else if (this.activeTab === 'global' && !this.currentActivationData.siteActivationMethod) return this.currentActivationData.toggleSelection;
    else if (this.activeTab === 'country' && this.globalData.siteActivationMethod && this.currentActivationData.siteActivationMethod) return false;
    else if (this.activeTab === 'country' && !this.globalData.siteActivationMethod && this.currentActivationData.siteActivationMethod) return this.globalData.toggleSelection;
    else return this.currentActivationData.toggleSelection;
  }

  checkDatesOutOfBound(inputEvent, field) {
    if (this.currentActivationData.siteStartDate.input == '' || !this.currentActivationData.toggleSelection) return false;
    let startDate, endDate;
    if (field === 'siteStartDate') { startDate = moment(inputEvent._inputValue); endDate = moment(this.currentActivationData.siteEndDate.input); }
    else { startDate = moment(this.currentActivationData.siteStartDate.input); endDate = moment(inputEvent._inputValue); }
    const inputsToCheck = this.inputGridData.slice(1, -1);
    const orderError = inputsToCheck.filter(d =>
      (moment(d.perc_trial_duration.input).diff(startDate) <= 0 || moment(d.perc_trial_duration.input).diff(endDate) >= 0) &&
      (d.perc_trial_duration.input !== null || d.perc_trial_duration.input !== '')
    );
    return Boolean(orderError.length ? ERROR_MESSAGES.badOrder : '');
  }

  enableCalculateButton() {
    return (
      this.chartPlotted || !this.hasMandatoryFields() || this.isError || this.popupOpen ||
      this.currentActivationData.siteStartDate.input == '' || this.currentActivationData.siteEndDate.input == ''
    );
  }

  generateNewVersionId(data) {
    this.saveFlyoutData(data);
  }
  isCohortStudy(): boolean {
    return this.studyDetails?.is_cohort === '1' || this.inputRequest?.input_request?.is_cohort === '1';
  }

  onCohortSelectionChange(selectedCohorts: any[], row: any): void {
    if (selectedCohorts && selectedCohorts.length < 2) {
      this.siteSharingCohortError = 'Please select at least 2 cohorts.';
      row.sitesSharedAmongCohort = row.sitesSharedAmongCohort?.length >= 2
        ? row.sitesSharedAmongCohort
        : selectedCohorts;
    } else {
      this.siteSharingCohortError = '';
      row.sitesSharedAmongCohort = selectedCohorts;
    }
  }
}